import { ChevronDownIcon } from "@heroicons/react/20/solid";
import React, { useState } from "react";
import { connect } from "react-redux";
import Select from "react-select";

const BambooSettings = ({
	bambooFields,
	category,
	disabled,
	settings,
	options,
	leave,
	updateSetting,
	updateOptions,
	categoryOptions,
	invert,
}) => {
	const [expand, setExpand] = useState(false);
	if (!categoryOptions || categoryOptions?.length <= 0) return null;

	const leftLabel = invert ? "Bamboo HR" : "Buddy";
	const rightLabel = invert ? "Buddy" : "Bamboo HR";
	const leftOptions = invert ? bambooFields : categoryOptions;
	const rightOptions = invert ? categoryOptions : bambooFields;

	return (
		<div
			className="row"
			style={{ paddingBottom: 0 }}
		>
			<div className="col-xs-12 pr-0 pl-0">
				<div className="col-xs-6">
					<h4>{category?.name}</h4>
				</div>
				<div className="col-xs-6">
					<button
						className="btn btn-default pull-right"
						onClick={() => {
							setExpand(!expand);
						}}
					>
						<ChevronDownIcon
							style={{
								height: "1.5em",
								float: "left",
								transform: expand ? "rotate(180deg)" : "rotate(0deg)",
								transition: "transform 0.2s ease-in-out",
							}}
						/>
					</button>
				</div>
			</div>
			<div className="clearfix" />
			{expand ? (
				<div className="form-inner-section">
					<div className="col-xs-6">
						<h5>{leftLabel}</h5>
					</div>
					<div className="col-xs-6">
						<h5>{rightLabel}</h5>
					</div>
					{leftOptions?.map((item) => {
						const fieldOptions = rightOptions
							?.filter((field) => field.type == item.type)
							?.map((field) => ({ ...field, label: field.name, value: field.id }));
						const selectedField =
							fieldOptions?.find((field) => field.value == settings?.[category?.name]?.[item.value]) ||
							null;
						const subOptions = item?.subOptions;
						return (
							<>
								<div
									className="col-xs-6"
									style={{ marginBottom: "1rem" }}
								>
									<Select
										isDisabled={true}
										value={item}
									/>
								</div>
								<div className="col-xs-6">
									<Select
										isDisabled={disabled}
										value={selectedField}
										isClearable
										onChange={(selected) => {
											const value = selected?.value || null
											updateSetting({ field: item?.value, value });
										}}
										options={fieldOptions}
									/>
								</div>
								<div
									className="col-xs-12"
									style={{ marginBottom: "1rem" }}
								>
									{selectedField &&
										subOptions?.map((subOption) => {
											const bambooSubOptions = selectedField?.subOptions?.map((option) => ({
												label: option.name,
												value: option.id,
											}));
											const selectedOption =
												bambooSubOptions?.find(
													(field) => field.value == options?.[item.value]?.[subOption?.value],
												) ||
												options?.[item.value]?.[subOption?.value] ||
												null;
											return (
												<div
													className="col-xs-12"
													style={{ marginBottom: "1rem" }}
												>
													<div className="col-xs-6">
														<Select
															isDisabled={true}
															value={subOption}
														/>
													</div>
													<div className="col-xs-6">
														{selectedField?.subOptions ? (
															<Select
																isDisabled={disabled}
																value={selectedOption}
																isClearable
																onChange={(selected) =>
																	updateOptions({
																		field: item?.value,
																		option: subOption?.value,
																		selectedOption: selected?.value,
																	})
																}
																options={bambooSubOptions}
															/>
														) : (
															<input
																disabled={disabled}
																className="form-control form-input"
																value={selectedOption}
																onChange={(e) =>
																	updateOptions({
																		field: item?.value,
																		option: subOption?.value,
																		selectedOption: e.target.value,
																	})
																}
															/>
														)}
													</div>
												</div>
											);
										})}
								</div>
							</>
						);
					})}
					<div className="clearfix" />
				</div>
			) : null}
		</div>
	);
};

const mapStateToProps = (state, ownProps) => {
	const { options } = { ...state.integration?.hris?.bambooHr };
	const { bambooFields, bambooLeaveTypes, buddyLeaveTypes } = { ...options };
	const { category, leave } = ownProps;
	const jurisdiction = state.company?.settings?.jurisdiction;
	const categoryOptions =
		Array.isArray(category?.subOptions) &&
		category?.subOptions
			?.filter((item) => (item.countrySpecific ? item.countrySpecific.includes(jurisdiction) : true))
			?.map((item) => ({ label: item.name, value: item.field, type: item.type, subOptions: item.subOptions }));

	return {
		bambooFields: leave
			? bambooLeaveTypes?.map((item) => ({ label: item.name, value: item.id, type: item.type }))
			: bambooFields,
		categoryOptions: leave ? buddyLeaveTypes : categoryOptions,
	};
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BambooSettings);
